import React from 'react';
import Modal from './Modal';
import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';

function AlertModal({
  isOpen,
  message,
  onClose,
  onConfirm,
  title = '提示',
  confirmText = '确定',
  cancelText = '',
  showCancel = false,
  type = 'info',
  closeOnBackdrop = true
}) {
  if (!isOpen) return null;

  const getIconAndColor = () => {
    switch (type) {
      case 'success':
        return {
          icon: CheckCircleIcon,
          iconColor: 'text-green-700',
          buttonClass: 'bg-green-700 hover:bg-green-800'
        };
      case 'error':
        return {
          icon: XCircleIcon,
          iconColor: 'text-red-600',
          buttonClass: 'bg-gray-800 hover:bg-gray-900'
        };
      case 'warning':
        return {
          icon: ExclamationTriangleIcon,
          iconColor: 'text-amber-600',
          buttonClass: 'bg-gray-800 hover:bg-gray-900'
        };
      default:
        return {
          icon: InformationCircleIcon,
          iconColor: 'text-gray-600',
          buttonClass: 'bg-green-700 hover:bg-green-800'
        };
    }
  };

  const { icon: Icon, iconColor, buttonClass } = getIconAndColor();

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm" closeOnBackdrop={closeOnBackdrop}>
      <div className="pt-1 pb-1">
        <div className="flex items-start gap-3">
          <Icon className={`h-6 w-6 flex-shrink-0 mt-0.5 ${iconColor}`} aria-hidden="true" />
          <p className="text-sm text-gray-700 dark:text-gray-200 leading-relaxed break-words">
            {message}
          </p>
        </div>
      </div>
      <div className="flex justify-end gap-2 mt-4">
        {showCancel && (
          <button
            type="button"
            className="px-4 py-2 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200 transition-colors text-sm"
            onClick={onClose}
          >
            {cancelText || '取消'}
          </button>
        )}
        <button
          type="button"
          className={`px-4 py-2 rounded-md text-white transition-colors text-sm ${buttonClass}`}
          onClick={handleConfirm}
        >
          {confirmText}
        </button>
      </div>
    </Modal>
  );
}

export default AlertModal;
